import { loadRazorpay } from "./loadRazorpay";

interface RazorpayOptions {
  key: string;
  subscription_id: string;
  onSuccess: (response: any) => void;
  onFailure?: (response: any) => void;
}

export const openRazorpayCheckout = async ({
  key,
  subscription_id,
  onSuccess,
  onFailure,
}: RazorpayOptions) => {
  const loaded = await loadRazorpay();

  if (!loaded) {
    throw new Error("Failed to load Razorpay");
  }

  const options = {
    key,
    subscription_id,
    name: "My Application",
    handler: onSuccess,
    
    theme: {
      color: "#FF8D28",
    },
  };
  const razorpay = new window.Razorpay(options);

  razorpay.on("payment.failed", (response: any) => {
    onFailure?.(response);
  });

  razorpay.open();
};